import React, {useState} from 'react';
import RoastBeans from '../../../RoastBeans';
import countRoast from '../../../../../scripts/utils/countRoast';
import getTasteStrFromTag from '../../../../../scripts/utils/getTasteStrFromTag';
import {ISimpleSubProduct} from '../types';
import useOutsideClickStateUpdater from '../../../../hooks/useOutsideClickStateUpdater';

interface SimpleSubTooltipProps {
  langStrings: Record<string, string>;
  product: ISimpleSubProduct;
}

const SimpleSubTooltip: React.FunctionComponent<SimpleSubTooltipProps> = ({
  langStrings,
  product
}: SimpleSubTooltipProps) => {
  const [isShown, setIsShown] = useState<boolean>(false);

  const {outsideClickRef} = useOutsideClickStateUpdater(setIsShown);

  const handleInfoBtnClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
    const tooltipElem: HTMLDivElement = outsideClickRef.current;

    // If we're too close to the right edge of the window, we flip the tooltip.
    if (window.innerWidth - e.pageX > 250) {
      tooltipElem.classList.add('simple-sub-tooltip--flipped');
    } else {
      tooltipElem.classList.remove('simple-sub-tooltip--flipped');
    }

    setIsShown(!isShown);
  };

  const roastCount: number = countRoast(product);
  const tasteStr: string = getTasteStrFromTag(product);

  if (roastCount > 0 || tasteStr) {
    return (
      <div className="simple-sub-tooltip" ref={outsideClickRef}>
        <button
          onClick={(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => handleInfoBtnClick(e)}
          className="simple-sub-tooltip-btn"
          aria-label="Simple Subscription Product Info"
        >
          i
        </button>

        {isShown && (
          <div className="simple-sub-tooltip-inner">
            {tasteStr && (
              <div className="simple-sub-tooltip-taste">
                <h5 className="simple-sub-tooltip-taste-title">
                  {langStrings.tastesLike}
                </h5>
                <p className="simple-sub-tooltip-taste-txt">
                  {tasteStr}
                </p>
              </div>
            )}

            {roastCount > 0 && (
              <div className="simple-sub-tooltip-roast">
                <h5 className="simple-sub-tooltip-roast-title">
                  {langStrings.roast}
                </h5>
                <RoastBeans roastCount={roastCount}/>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default SimpleSubTooltip;